import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import messages from '../../locale/messages';
import InboxMessageContainer from './InboxMessageContainer';

const title = 'Inbox Message Configurations';

export default function action({ store, intl }) {

  const title = intl?.formatMessage(messages.inboxMessageConfigurationsLabel);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout><InboxMessageContainer title={title} /></UserLayout>,
  };
}
